export const colorInterpolate = (colorA, colorB, intval) => {
    const color = [0, 0, 0];
    return color.map((_, i) => Math.round(colorA[i] * (1 - intval) + colorB[i] * intval));
};
